import { SvgIcon, SvgIconProps } from "@mui/material";

export const NotificationsNormalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "19", height: "22", fill: "none" }}
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
    >
      <path
        d="M12.4635 18C12.4635 19.6569 11.1204 21 9.46351 21C7.80666 21 6.46351 19.6569 6.46351 18M11.26 5.23856C11.6955 4.78864 11.9635 4.17562 11.9635 3.5C11.9635 2.11929 10.8442 1 9.46351 1C8.0828 1 6.96351 2.11929 6.96351 3.5C6.96351 4.17562 7.23151 4.78864 7.66701 5.23856M15.4635 10.2C15.4635 8.82087 14.8314 7.49823 13.7062 6.52304C12.5809 5.54786 11.0548 5 9.46351 5C7.87221 5 6.34609 5.54786 5.22087 6.52304C4.09565 7.49823 3.46351 8.82087 3.46351 10.2C3.46351 12.4818 2.89764 14.1506 2.19158 15.3447C1.38685 16.7056 0.984487 17.3861 1.00038 17.5486C1.01855 17.7346 1.05203 17.7933 1.20285 17.9036C1.33468 18 1.99702 18 3.3217 18H15.6053C16.93 18 17.5923 18 17.7242 17.9036C17.875 17.7933 17.9085 17.7346 17.9266 17.5486C17.9425 17.3861 17.5402 16.7056 16.7354 15.3447C16.0294 14.1506 15.4635 12.4818 15.4635 10.2Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NotificationsOnIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "22", height: "22", fill: "none" }}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.7348 16.9891C15.1636 18.5895 14.2139 20.2346 12.6135 20.6634C11.0131 21.0922 9.36808 20.1425 8.93925 18.5421M1.14573 10.5877C0.756233 9.18949 1.16128 7.67785 2.19768 6.66174M11.2352 4.71521C11.5394 4.16791 11.6396 3.50641 11.4648 2.85382C11.1074 1.52015 9.73656 0.728696 8.4029 1.08605C7.06923 1.4434 6.27777 2.81425 6.63513 4.14791C6.80999 4.80051 7.22752 5.32328 7.76463 5.64515M19.4079 5.69436C19.0461 4.28876 17.9395 3.18216 16.5339 2.82038M16.5795 8.41965C16.2226 7.08751 15.2697 5.97355 13.9304 5.32282C12.5911 4.67209 10.9752 4.53789 9.43811 4.94975C7.90103 5.36161 6.56871 6.28578 5.73423 7.51897C4.89975 8.75216 4.63147 10.1933 4.98842 11.5255C5.57899 13.7295 5.46431 15.4879 5.09136 16.8241C4.66629 18.3469 4.45376 19.1083 4.51118 19.2612C4.57687 19.4362 4.62439 19.4842 4.79862 19.5517C4.95091 19.6107 5.59068 19.4393 6.87022 19.0964L18.7353 15.9172C20.0148 15.5743 20.6546 15.4029 20.757 15.2756C20.8741 15.1301 20.8913 15.0647 20.8607 14.8804C20.834 14.7193 20.2692 14.1661 19.1397 13.0598C18.1486 12.0892 17.1701 10.6237 16.5795 8.41965Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NoNotificationsFigure = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "76", height: "103", fill: "none" }}
      width="76"
      height="103"
      viewBox="0 0 76 103"
      fill="none"
    >
      <path
        d="M31.2396 98.5299C31.2396 98.5299 32.0186 100.16 33.5719 100.141C35.1251 100.122 35.6761 101.554 34.3319 102.1C32.9876 102.647 29.2351 101.201 29.2351 101.201L29.0879 98.3745L31.2396 98.5299Z"
        fill="#106048"
      />
      <path
        d="M15.318 98.5299C15.318 98.5299 14.539 100.16 12.9857 100.141C11.4324 100.122 10.8814 101.554 12.2304 102.1C13.5794 102.647 17.3272 101.201 17.3272 101.201L17.4745 98.3745L15.318 98.5299Z"
        fill="#106048"
      />
      <path
        d="M23.3408 15.7259C23.3408 15.7259 38.0658 17.5534 37.5623 37.4773C37.0588 57.4011 55.3463 61.3624 55.3463 61.3624L53.4083 65.9453C53.4083 65.9453 39.4623 63.6468 31.4586 50.1758C23.4548 36.7048 23.3408 15.7259 23.3408 15.7259Z"
        fill="#106048"
      />
      <path
        d="M23.3408 15.7259C23.3408 15.7259 38.0658 17.5534 37.5623 37.4773C37.0588 57.4011 55.3463 61.3624 55.3463 61.3624L53.4083 65.9453C53.4083 65.9453 39.4623 63.6468 31.4586 50.1758C23.4548 36.7048 23.3408 15.7259 23.3408 15.7259Z"
        fill="#9FBFB6"
      />
      <path d="M19.7973 5.18933L17.0518 15.3632L22.8135 16.4654L22.5 8.6183L19.7973 5.18933Z" fill="#F4A28C" />
      <path
        opacity="0.31"
        d="M22.6423 10.3327C21.936 10.0762 21.3203 9.6212 20.8706 9.02332C20.8706 9.02332 20.7518 10.9498 22.6756 13.0599L22.6423 10.3327Z"
        fill="#CE8172"
      />
      <path
        d="M16.6195 15.2407L23.925 15.8483C23.925 15.8483 38.3555 20.0545 37.776 33.5066C37.1965 46.9587 35.876 63.4348 35.876 63.4348L16.4675 65.9547C16.4675 65.9547 -15.823 22.4048 16.6195 15.2407Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M12.6814 22.8523C12.6814 22.8523 20.4144 27.2186 19.9299 35.3954C19.4454 43.5722 17.4883 52.8558 26.0004 51.9091C34.5124 50.9623 36.9254 48.2823 36.9254 48.2823L35.8471 63.4348L16.4386 65.9547L14.6906 63.4348C14.6906 63.4348 -1.72541 34.2367 12.6814 22.8523Z"
        fill="#111111"
      />
      <path d="M44.5132 38.0315L49.457 39.6187L52.3408 30.7864L47.397 29.1992L44.5132 38.0315Z" fill="#111111" />
      <path
        d="M44.0126 42.2109C44.0126 42.2109 48.6439 38.9421 47.5086 36.8979C46.3734 34.8537 41.8086 39.545 41.8086 39.545L44.0126 42.2109Z"
        fill="#F4A28C"
      />
      <path
        d="M16.4482 65.9547L35.8567 63.4348L32.185 98.7607H27.6582C27.6582 98.7607 27.9955 80.6456 25.2405 75.2713C22.4855 69.8971 16.4482 65.9547 16.4482 65.9547Z"
        fill="#111111"
      />
      <path
        d="M16.4486 65.9547L13.5986 98.7513H18.5576C18.5576 98.7513 22.0109 73.8959 30.9076 67.4854L16.4486 65.9547Z"
        fill="#111111"
      />
      <path
        d="M25.8681 5.38233C25.8681 5.38233 25.0226 8.48631 23.7733 10.2997C23.652 10.4751 23.4969 10.625 23.317 10.7408C23.137 10.8566 22.9358 10.936 22.7249 10.9745C22.5139 11.0131 22.2974 11.0099 22.0877 10.9652C21.878 10.9205 21.6792 10.8352 21.5028 10.7142C20.5908 10.0783 19.5411 8.95732 19.7928 7.23812L19.8546 4.27074C19.9302 3.67843 20.1892 3.12395 20.5958 2.68363C21.0024 2.2433 21.5367 1.93881 22.1251 1.81205C24.2958 1.20916 26.4761 3.51712 25.8681 5.38233Z"
        fill="#F4A28C"
      />
      <path
        d="M25.065 5.23162C24.1116 4.92705 23.1967 4.51455 22.3385 4.00228C22.4587 4.51098 22.426 5.04343 22.2445 5.53392C22.0631 6.02442 21.7407 6.45148 21.3173 6.76242C20.9132 7.07176 20.4133 7.23242 19.9031 7.21696C19.3928 7.20149 18.9038 7.01087 18.5195 6.67763L20.0015 2.81533C20.1961 2.25763 20.5381 1.76194 20.9918 1.38001C21.4455 0.998067 21.9942 0.743875 22.5808 0.643956C23.09 0.559114 23.6039 0.50563 24.1198 0.483812C25.4118 0.446131 26.7893 1.78852 28.0765 1.42584C28.2057 1.38722 28.3427 1.38251 28.4742 1.41218C28.6057 1.44184 28.7273 1.50486 28.8268 1.59507C28.9264 1.68527 29.0007 1.79958 29.0423 1.92678C29.084 2.05399 29.0917 2.18975 29.0645 2.32076C28.8033 3.56424 27.9055 5.34467 26.0578 5.4059C25.7192 5.40473 25.3834 5.34578 25.065 5.23162Z"
        fill="#111111"
      />
      <path
        d="M21.6776 6.79075C21.6776 6.79075 22.0814 5.62264 21.1694 5.37772C20.2574 5.13279 19.6589 6.83786 20.7989 7.42662L21.6776 6.79075Z"
        fill="#F4A28C"
      />
      <path
        d="M25.2311 7.3089L25.6491 8.77845C25.6724 8.86193 25.6742 8.94986 25.6543 9.03421C25.6345 9.11855 25.5937 9.19663 25.5355 9.26128C25.4774 9.32594 25.4039 9.37512 25.3217 9.40432C25.2394 9.43352 25.1511 9.44182 25.0648 9.42845L23.8203 9.2212L25.2311 7.3089Z"
        fill="#F4A28C"
      />
      <path
        d="M13.2331 24.0487C12.9511 23.1533 12.4261 22.3519 11.7157 21.7324C11.0052 21.1129 10.1366 20.6991 9.20492 20.5362C8.27321 20.3733 7.31427 20.4676 6.43299 20.8088C5.55171 21.15 4.78202 21.725 4.20814 22.4708C2.07539 25.2357 0.21339 29.3335 0.71689 35.094C1.80939 47.4816 5.66639 61.791 14.4919 59.987C23.3174 58.183 44.8064 43.153 44.8064 43.153L41.8566 39.5451C41.8566 39.5451 23.8304 49.2856 17.0759 48.2023C11.5754 47.3262 16.3254 33.9494 13.2331 24.0487Z"
        fill="#106048"
      />
      <path
        d="M13.2331 24.0487C12.9511 23.1533 12.4261 22.3519 11.7157 21.7324C11.0052 21.1129 10.1366 20.6991 9.20492 20.5362C8.27321 20.3733 7.31427 20.4676 6.43299 20.8088C5.55171 21.15 4.78202 21.725 4.20814 22.4708C2.07539 25.2357 0.21339 29.3335 0.71689 35.094C1.80939 47.4816 5.66639 61.791 14.4919 59.987C23.3174 58.183 44.8064 43.153 44.8064 43.153L41.8566 39.5451C41.8566 39.5451 23.8304 49.2856 17.0759 48.2023C11.5754 47.3262 16.3254 33.9494 13.2331 24.0487Z"
        fill="#9FBFB6"
      />
      <path
        d="M55.0425 62.0971C55.0425 62.0971 60.1392 61.5507 60.0205 64.0754C59.9017 66.6 53.9072 64.7772 53.9072 64.7772L55.0425 62.0971Z"
        fill="#F4A28C"
      />
      <path d="M70.1639 2.02032H45V21.4517H70.1639V2.02032Z" fill="#106048" />
      <path d="M47.9766 20.0037L50.039 27.5814L51.9878 20.0037H47.9766Z" fill="#106048" />
      <path
        d="M70.5396 25.1438C73.0494 25.1438 75.084 23.1298 75.084 20.6453C75.084 18.1608 73.0494 16.1468 70.5396 16.1468C68.0297 16.1468 65.9951 18.1608 65.9951 20.6453C65.9951 23.1298 68.0297 25.1438 70.5396 25.1438Z"
        fill="#A0A0A0"
      />
      <path d="M71.2726 18.6459V22.5897H70.4374V19.4347L69.5283 19.9981V19.26L70.5056 18.6459H71.2726Z" fill="white" />
      <path
        d="M57.2115 6.60352H57.7988C58.7348 6.60352 59.6323 6.97015 60.2941 7.62276C60.9559 8.27537 61.3277 9.16051 61.3277 10.0834V14.152H53.6826V10.0834C53.6826 9.16051 54.0544 8.27537 54.7162 7.62276C55.378 6.97015 56.2756 6.60352 57.2115 6.60352Z"
        fill="white"
      />
      <path
        d="M57.5765 17.7053C58.4477 17.7053 59.1539 17.0089 59.1539 16.1497C59.1539 15.2906 58.4477 14.5942 57.5765 14.5942C56.7053 14.5942 55.999 15.2906 55.999 16.1497C55.999 17.0089 56.7053 17.7053 57.5765 17.7053Z"
        fill="#707070"
      />
      <path
        d="M57.5765 17.7053C58.4477 17.7053 59.1539 17.0089 59.1539 16.1497C59.1539 15.2906 58.4477 14.5942 57.5765 14.5942C56.7053 14.5942 55.999 15.2906 55.999 16.1497C55.999 17.0089 56.7053 17.7053 57.5765 17.7053Z"
        fill="white"
      />
      <path
        d="M61.1816 13.1994H53.793C53.1204 13.1994 52.5752 13.7371 52.5752 14.4004V14.6013C52.5752 15.2646 53.1204 15.8023 53.793 15.8023H61.1816C61.8542 15.8023 62.3995 15.2646 62.3995 14.6013V14.4004C62.3995 13.7371 61.8542 13.1994 61.1816 13.1994Z"
        fill="#707070"
      />
      <path
        opacity="0.63"
        d="M61.1816 13.1994H53.793C53.1204 13.1994 52.5752 13.7371 52.5752 14.4004V14.6013C52.5752 15.2646 53.1204 15.8023 53.793 15.8023H61.1816C61.8542 15.8023 62.3995 15.2646 62.3995 14.6013V14.4004C62.3995 13.7371 61.8542 13.1994 61.1816 13.1994Z"
        fill="white"
      />
      <path
        d="M57.5761 7.09998C58.1811 7.09998 58.6716 6.61627 58.6716 6.0196C58.6716 5.42292 58.1811 4.93921 57.5761 4.93921C56.971 4.93921 56.4805 5.42292 56.4805 6.0196C56.4805 6.61627 56.971 7.09998 57.5761 7.09998Z"
        fill="#707070"
      />
      <path
        d="M57.5761 7.09998C58.1811 7.09998 58.6716 6.61627 58.6716 6.0196C58.6716 5.42292 58.1811 4.93921 57.5761 4.93921C56.971 4.93921 56.4805 5.42292 56.4805 6.0196C56.4805 6.61627 56.971 7.09998 57.5761 7.09998Z"
        fill="white"
      />
    </SvgIcon>
  );
};
